import React from 'react'

// Components
import { TradeInput } from './components/TradeInput'

// Styles
import {
  TradePairContainer,
  TradePairSeparator,
  TradePairSeparatorIcon,
} from './tradePair.styles'

// Types
import { CoinImage } from 'components/coinIcon/coinIcon.types'

interface Coin {
  name: string
  image: CoinImage
  value: string
  min?: string
}

interface TradePairProps {
  coins: [Coin, Coin]
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  disabledShares?: boolean
  minDemand?: number
}

export const TradePair = ({
  coins,
  disabled,
  disabledShares,
  minDemand,
  onChange,
}: TradePairProps): React.ReactElement => {
  return (
    <TradePairContainer>
      <TradeInput
        disabled={disabled || disabledShares}
        onChange={onChange}
        value={coins[0].value}
        coinImage={coins[0].image}
        coinName={coins[0].name}
        min={coins[0].min}
      />
      <TradePairSeparator>
        <TradePairSeparatorIcon />
      </TradePairSeparator>
      <TradeInput
        disabled={disabled}
        onChange={onChange}
        value={coins[1].value}
        coinImage={coins[1].image}
        coinName={coins[1].name}
        min={disabledShares?minDemand:coins[1].min}
      />
    </TradePairContainer>
  )
}
